import { apiRequestBase } from "./client";
import { env } from "../config/env";

interface CouponPayloadItem {
  id: number;
  amount: number;
  brandId: number | null;
  categoryIds: number[];
  manufacturId: number | null;
}

export interface CouponPayload {
  items: CouponPayloadItem[];
  code: string;
  subTotal: number;
  grandTotal: number;
  customerId: number | null;
}

export const promotionApi = {
  applyCoupon: (payload: CouponPayload) =>
    apiRequestBase<any>(env.discountBaseUrl, `/Promotions/Apply`, {
      method: "POST",
      body: payload,
    }),
};
